import { TasksController } from './tasks.controller';

export const TasksComponent: ng.IComponentOptions = {
  bindings: {
    profile: '<',
  },
  templateUrl: 'tasks/tasks/tasks.html',
  controller: TasksController,
};
